import {
  FETCH_CALENDAR_ITEMS_START,
  FETCH_CALENDAR_ITEMS_FULFILLED,
  FETCH_CALENDAR_ITEMS_REJECTED,
  FETCH_SAVED_WORKOUT_START,
  FETCH_SAVED_WORKOUT_FULFILLED,
  FETCH_SAVED_WORKOUT_REJECTED,
  FETCH_ALL_EXERCISES_START,
  FETCH_ALL_EXERCISES_FULFILLED,
  FETCH_ALL_EXERCISES_REJECTED,
  FETCH_EXERCISE_START,
  FETCH_EXERCISE_FULFILLED,
  FETCH_EXERCISE_REJECTED,
  UPLOAD_CALENDAR_MEDIA_START,
  UPLOAD_CALENDAR_MEDIA_FULFILLED,
  UPLOAD_CALENDAR_MEDIA_REJECTED,
  UPDATE_SAVED_WORKOUT_ITEM_START,
  UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
  UPDATE_SAVED_WORKOUT_ITEM_REJECTED,
  EDIT_THUMBNAIL_START,
  EDIT_THUMBNAIL_FULFUILLED,
  EDIT_THUMBNAIL_REJECTED,
  CREATE_EXERCISE_START,
  CREATE_EXERCISE_FULFILLED,
  CREATE_EXERCISE_REJECTED,
  FETCH_DOCUMENTS_START,
  FETCH_DOCUMENTS_FULFILLED,
  FETCH_DOCUMENTS_REJECTED,
  FETCH_DOCUMENT_START,
  FETCH_DOCUMENT_FULFILLED,
  FETCH_DOCUMENT_REJECTED,
  FETCH_FOLDER_START,
  FETCH_FOLDER_FULFILLED,
  FETCH_FOLDER_REJECTED,
  FETCH_PARENT_CALENDARS_START,
  FETCH_PARENT_CALENDARS_FULFILLED,
  FETCH_PARENT_CALENDARS_REJECTED,
  FETCH_ACCOUNT_TAGS_START,
  FETCH_ACCOUNT_TAGS_FULFILLED,
  FETCH_ACCOUNT_TAGS_REJECTED,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED,
  CREATE_QUESTION_FOR_ACCOUNT_START,
  CREATE_QUESTION_FOR_ACCOUNT_FULTILLED,
  CREATE_QUESTION_FOR_ACCOUNT_REJECTED,
  SAVE_CALENDAR_EXERCISE_START,
  SAVE_CALENDAR_EXERCISE_FULFILLED,
  SAVE_CALENDAR_EXERCISE_REJECTED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_START,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED,
  REVERT_SWAPPED_ITEM_START,
  REVERT_SWAPPED_ITEM_FULFILLED,
  REVERT_SWAPPED_ITEM_REJECTED,
  TOGGLE_ANALYTICS_STRIKETHROUGH,
  SET_IS_TV_MODE,
  FETCH_AND_SET_URL_ATHLETE_START,
  FETCH_AND_SET_URL_ATHLETE_FULFILLED,
  FETCH_AND_SET_URL_ATHLETE_REJECTED,
  FETCH_AND_SET_URL_CALENDAR_START,
  FETCH_AND_SET_URL_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_CALENDAR_REJECTED,
  FETCH_AND_SET_URL_CHILD_CALENDAR_START,
  FETCH_AND_SET_URL_CHILD_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_CHILD_CALENDAR_REJECTED,
  FETCH_AND_SET_URL_PROGRAM_START,
  FETCH_AND_SET_URL_PROGRAM_FULFILLED,
  FETCH_AND_SET_URL_PROGRAM_REJECTED,
  FETCH_AND_SET_DEFAULT_CALENDAR_START,
  FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED,
  FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED,
  FETCH_PROGRAM_TAGS_START,
  FETCH_PROGRAM_TAGS_FULFILLED,
  FETCH_PROGRAM_TAGS_REJECTED,
} from './actionTypes';

const initialState = {
  isCalendarItemsLoading: true,
  isFetchedExerciseLoading: false,
  isAllExercisesLoading: false,
  isMediaLoading: false,
  isThumbnailLoading: false,
  isCreateExerciseLoading: false,
  isDocumentsLoading: false,
  isDocumentLoading: false,
  isFolderLoading: false,
  isParentCalendarsLoading: false,
  isAccountTagsLoading: false,
  isProgramTagsLoading: false,
  isQuestionsForAccountLoading: false,
  isNewQuestionLoading: false,
  isCalendarItemSaving: false,
  itemIndexBeingSaved: null,
  isCalendarItemUpdating: false,
  itemIndexBeingUpdated: null,
  itemIndexBeingReverted: null,
  isSwappedItemReverting: false,
  isAnalyticsDisabled: false,
  isTvMode: false,
  swapLoadingAssignedIds: {},
  savingAssignedIds: {},
  autoLoadingCount: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CALENDAR_ITEMS_START: {
      return {
        ...state,
        isCalendarItemsLoading: true,
      };
    }
    case FETCH_CALENDAR_ITEMS_FULFILLED: {
      return {
        ...state,
        isCalendarItemsLoading: false,
      };
    }
    case FETCH_CALENDAR_ITEMS_REJECTED: {
      return {
        ...state,
        isCalendarItemsLoading: false,
      };
    }
    case FETCH_SAVED_WORKOUT_START: {
      return {
        ...state,
        isSavedItemsLoading: true,
      };
    }
    case FETCH_SAVED_WORKOUT_FULFILLED: {
      return {
        ...state,
        isSavedItemsLoading: false,
      };
    }
    case FETCH_SAVED_WORKOUT_REJECTED: {
      return {
        ...state,
        isSavedItemsLoading: false,
      };
    }
    case FETCH_PARENT_CALENDARS_START: {
      return {
        ...state,
        isParentCalendarsLoading: true,
      };
    }
    case FETCH_PARENT_CALENDARS_FULFILLED: {
      return {
        ...state,
        isParentCalendarsLoading: false,
      };
    }
    case FETCH_PARENT_CALENDARS_REJECTED: {
      return {
        ...state,
        isParentCalendarsLoading: false,
      };
    }
    case FETCH_ALL_EXERCISES_START: {
      return {
        ...state,
        isAllExercisesLoading: true,
      };
    }
    case FETCH_ALL_EXERCISES_FULFILLED: {
      return {
        ...state,
        isAllExercisesLoading: false,
      };
    }
    case FETCH_ALL_EXERCISES_REJECTED: {
      return {
        ...state,
        isAllExercisesLoading: false,
      };
    }
    case FETCH_EXERCISE_START: {
      return {
        ...state,
        isFetchedExerciseLoading: true,
      };
    }
    case FETCH_EXERCISE_FULFILLED: {
      return {
        ...state,
        isFetchedExerciseLoading: false,
      };
    }
    case FETCH_EXERCISE_REJECTED: {
      return {
        ...state,
        isFetchedExerciseLoading: false,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_START: {
      return {
        ...state,
        isMediaLoading: true,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_FULFILLED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_CALENDAR_MEDIA_REJECTED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case EDIT_THUMBNAIL_START: {
      return {
        ...state,
        isThumbnailLoading: true,
      };
    }
    case EDIT_THUMBNAIL_FULFUILLED: {
      return {
        ...state,
        isThumbnailLoading: false,
      };
    }
    case EDIT_THUMBNAIL_REJECTED: {
      return {
        ...state,
        isThumbnailLoading: false,
      };
    }
    case CREATE_EXERCISE_START: {
      return {
        ...state,
        isCreateExerciseLoading: true,
      };
    }
    case CREATE_EXERCISE_FULFILLED: {
      return {
        ...state,
        isCreateExerciseLoading: false,
      };
    }
    case CREATE_EXERCISE_REJECTED: {
      return {
        ...state,
        isCreateExerciseLoading: false,
      };
    }
    case FETCH_DOCUMENTS_START: {
      return {
        ...state,
        isDocumentsLoading: true,
      };
    }
    case FETCH_DOCUMENTS_FULFILLED: {
      return {
        ...state,
        isDocumentsLoading: false,
      };
    }
    case FETCH_DOCUMENTS_REJECTED: {
      return {
        ...state,
        isDocumentsLoading: false,
      };
    }
    case FETCH_DOCUMENT_START: {
      return {
        ...state,
        isDocumentLoading: true,
      };
    }
    case FETCH_DOCUMENT_FULFILLED: {
      return {
        ...state,
        isDocumentLoading: false,
      };
    }
    case FETCH_DOCUMENT_REJECTED: {
      return {
        ...state,
        isDocumentLoading: false,
      };
    }
    case FETCH_FOLDER_START: {
      return {
        ...state,
        isFolderLoading: true,
      };
    }
    case FETCH_FOLDER_FULFILLED: {
      return {
        ...state,
        isFolderLoading: false,
      };
    }
    case FETCH_FOLDER_REJECTED: {
      return {
        ...state,
        isFolderLoading: false,
      };
    }
    case FETCH_ACCOUNT_TAGS_START: {
      return {
        ...state,
        isAccountTagsLoading: true,
      };
    }
    case FETCH_ACCOUNT_TAGS_FULFILLED: {
      return {
        ...state,
        isAccountTagsLoading: false,
      };
    }
    case FETCH_ACCOUNT_TAGS_REJECTED: {
      return {
        ...state,
        isAccountTagsLoading: false,
      };
    }
    case FETCH_PROGRAM_TAGS_START: {
      return {
        ...state,
        isProgramTagsLoading: true,
      };
    }
    case FETCH_PROGRAM_TAGS_FULFILLED: {
      return {
        ...state,
        isProgramTagsLoading: false,
      };
    }
    case FETCH_PROGRAM_TAGS_REJECTED: {
      return {
        ...state,
        isProgramTagsLoading: false,
      };
    }
    case FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START: {
      return {
        ...state,
        isQuestionsForAccountLoading: true,
      };
    }
    case FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED: {
      return {
        ...state,
        isQuestionsForAccountLoading: false,
      };
    }
    case FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED: {
      return {
        ...state,
        isQuestionsForAccountLoading: false,
      };
    }
    case CREATE_QUESTION_FOR_ACCOUNT_START: {
      return {
        ...state,
        isNewQuestionLoading: true,
      };
    }
    case CREATE_QUESTION_FOR_ACCOUNT_FULTILLED: {
      return {
        ...state,
        isNewQuestionLoading: false,
      };
    }
    case CREATE_QUESTION_FOR_ACCOUNT_REJECTED: {
      return {
        ...state,
        isNewQuestionLoading: false,
      };
    }
    case SAVE_CALENDAR_EXERCISE_START:
    case SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START: {
      const id = action?.payload?.preSwappedAssignedId;
      return {
        ...state,
        isCalendarItemSaving: true,
        itemIndexBeingSaved: action.payload.itemIndex,
        savingAssignedIds: id != null
          ? { ...state.savingAssignedIds, [id]: true }
          : state.savingAssignedIds,
      };
    }
    case SAVE_CALENDAR_EXERCISE_FULFILLED:
    case SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED: {
      const id = action?.payload?.preSwappedAssignedId;
      const { [id]: _saveFulfilled, ...remainingSavingIds } = state.savingAssignedIds;
      return {
        ...state,
        isCalendarItemSaving: false,
        itemIndexBeingSaved: null,
        savingAssignedIds: id != null ? remainingSavingIds : state.savingAssignedIds,
      };
    }
    case SAVE_CALENDAR_EXERCISE_REJECTED:
    case SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED: {
      const id = action?.payload?.preSwappedAssignedId;
      const { [id]: _saveRejected, ...remainingSavingIds } = state.savingAssignedIds;
      return {
        ...state,
        isCalendarItemSaving: false,
        itemIndexBeingSaved: null,
        savingAssignedIds: id != null ? remainingSavingIds : state.savingAssignedIds,
      };
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_START: {
      return {
        ...state,
        isCalendarItemUpdating: true,
        itemIndexBeingUpdated: action.payload.itemIndex,
      };
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED: {
      return {
        ...state,
        isCalendarItemUpdating: false,
        itemIndexBeingUpdated: null,
      };
    }
    case UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED: {
      return {
        ...state,
        isCalendarItemUpdating: false,
        itemIndexBeingUpdated: null,
      };
    }
    case UPDATE_SAVED_WORKOUT_ITEM_START: {
      return {
        ...state,
        isCalendarItemUpdating: true,
        itemIndexBeingUpdated: action.payload.itemIndex,
      };
    }
    case UPDATE_SAVED_WORKOUT_ITEM_FULFILLED: {
      return {
        ...state,
        isCalendarItemUpdating: false,
        itemIndexBeingUpdated: null,
      };
    }
    case UPDATE_SAVED_WORKOUT_ITEM_REJECTED: {
      return {
        ...state,
        isCalendarItemUpdating: false,
        itemIndexBeingUpdated: null,
      };
    }
    case SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START: {
      const id = action?.payload?.preSwappedAssignedId;
      return {
        ...state,
        isCalendarItemUpdating: true,
        swapLoadingAssignedIds: id != null
          ? { ...state.swapLoadingAssignedIds, [id]: true }
          : state.swapLoadingAssignedIds,
        itemIndexBeingUpdated: action.payload.itemIndex,
      };
    }
    case SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED: {
      const id = action?.payload?.preSwappedAssignedId;
      const { [id]: _swapFulfilled, ...remainingSwapIds } = state.swapLoadingAssignedIds;
      return {
        ...state,
        isCalendarItemUpdating: false,
        swapLoadingAssignedIds: id != null ? remainingSwapIds : state.swapLoadingAssignedIds,
        itemIndexBeingUpdated: null,
      };
    }
    case SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED: {
      const id = action?.payload?.preSwappedAssignedId;
      const { [id]: _swapRejected, ...remainingSwapIds } = state.swapLoadingAssignedIds;
      return {
        ...state,
        isCalendarItemUpdating: false,
        swapLoadingAssignedIds: id != null ? remainingSwapIds : state.swapLoadingAssignedIds,
        itemIndexBeingUpdated: null,
      };
    }
    case REVERT_SWAPPED_ITEM_START: {
      const id = action?.payload?.assignedId;
      return {
        ...state,
        isSwappedItemReverting: true,
        itemIndexBeingReverted: action.payload.itemIndex,
        swapLoadingAssignedIds: id != null
          ? { ...state.swapLoadingAssignedIds, [id]: true }
          : state.swapLoadingAssignedIds,
      };
    }
    case REVERT_SWAPPED_ITEM_FULFILLED: {
      const id = action?.payload?.preRevertedAssignedId;
      const { [id]: _revertFulfilled, ...remainingSwapIds } = state.swapLoadingAssignedIds;
      return {
        ...state,
        isSwappedItemReverting: false,
        itemIndexBeingReverted: null,
        swapLoadingAssignedIds: id != null ? remainingSwapIds : state.swapLoadingAssignedIds,
      };
    }
    case REVERT_SWAPPED_ITEM_REJECTED: {
      const id = action?.payload?.assignedId;
      const { [id]: _revertRejected, ...remainingSwapIds } = state.swapLoadingAssignedIds;
      return {
        ...state,
        isSwappedItemReverting: false,
        itemIndexBeingReverted: null,
        swapLoadingAssignedIds: id != null ? remainingSwapIds : state.swapLoadingAssignedIds,
      };
    }
    case TOGGLE_ANALYTICS_STRIKETHROUGH: {
      return {
        ...state,
        isAnalyticsDisabled: !state.isAnalyticsDisabled,
      };
    }
    case SET_IS_TV_MODE: {
      return {
        ...state,
        isTvMode: action.payload,
      };
    }
    case FETCH_AND_SET_URL_ATHLETE_START:
    case FETCH_AND_SET_URL_CALENDAR_START:
    case FETCH_AND_SET_URL_CHILD_CALENDAR_START:
    case FETCH_AND_SET_URL_PROGRAM_START:
    case FETCH_AND_SET_DEFAULT_CALENDAR_START: {
      return {
        ...state,
        autoLoadingCount: state.autoLoadingCount + 1,
      };
    }
    case FETCH_AND_SET_URL_ATHLETE_FULFILLED:
    case FETCH_AND_SET_URL_ATHLETE_REJECTED:
    case FETCH_AND_SET_URL_CALENDAR_FULFILLED:
    case FETCH_AND_SET_URL_CALENDAR_REJECTED:
    case FETCH_AND_SET_URL_CHILD_CALENDAR_FULFILLED:
    case FETCH_AND_SET_URL_CHILD_CALENDAR_REJECTED:
    case FETCH_AND_SET_URL_PROGRAM_FULFILLED:
    case FETCH_AND_SET_URL_PROGRAM_REJECTED:
    case FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED:
    case FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED: {
      return {
        ...state,
        autoLoadingCount: Math.max(0, state.autoLoadingCount - 1),
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
